import React, { useEffect, useState } from "react";
import { CardContainer, useStyles, OnlDropdown } from "../../../components";
import { CustomTable2 } from "../../../components/Tables2";
import { Sorting } from "../../../components/Icons";
// import { OKPosOptionSortingModal, OKPosOptionEditModal } from "./OKPosOptionModals";
import { OKPosOptionSortingModal, OKPosOptionEditModal } from "./OKPosOptionModals2";

const tableHeaders = {

  // SDA
  SdaClsList: [
    { name: "SDA_CLS_CD", displayName: "코드(SDA_CLS_CD)", selectKey: true },
    { name: "SDA_CLS_NM", displayName: "이름" },
    { name: "USE_YN", displayName: "사용여부" },
    { name: "required", displayName: "필수여부", type: "boolean" },
  ],
  SdaCdList: [
    { name: "SDA_CLS_CD", displayName: "분류코드(SDA_CLS_CD)" },
    { name: "SDA_CD", displayName: "코드(SDA_CD)", selectKey: true },
    { name: "SDA_NM", displayName: "이름" },
    // { name: "PROD_CD", displayName: "아이템코드" },
    // { name: "SDS_PROD_UPRC", displayName: "가격", type: "number" },
    { name: "isSoldout", displayName: "품절" },
  ],

  // SDS
  SdsGrList: [
    { name: "SDS_GRP_CD", displayName: "그룹코드(SDS_GRP_CD)" },
    { name: "SDS_GRP_NM", displayName: "이름" },
    { name: "USE_YN", displayName: "사용여부" },
  ],
  SdsClsList: [
    { name: "selected", displayName: "선택", type: "checkbox", keyName: "SDS_CLS_CD" },
    { name: "SDS_CLS_CD", displayName: "코드(SDS_CLS_CD)" },
    { name: "SDS_GRP_CD", displayName: "그룹코드(SDS_GRP_CD)", sorting: true },
    // { name: "SDS_CLS_CD", displayName: "코드(SDS_CLS_CD)", selectKey: true },
    { name: "SDS_CLS_NM", displayName: "이름" },
    // { name: "USE_YN", displayName: "사용여부" },
    { name: "required", displayName: "필수여부", type: "boolean" },
  ],
  SdsCdList: [
    { name: "SDS_CLS_CD", displayName: "분류코드(SDS_CLS_CD)", sorting: true },
    { name: "SDS_CD", displayName: "코드(SDS_CD)", selectKey: true },
    { name: "PROD_CD", displayName: "PROD_CD" },
    { name: "SDS_NM", displayName: "이름" }, 
    { name: "SDS_PROD_UPRC", displayName: "가격", type: "number" },
    { name: "isSoldout", displayName: "품절" },
    // { name: "className", displayName: "분류명" },
  ],
}

export const optionTypes = {
  sdsGr: "sdsGr",
  sdsCls: "SdsCls", sdsSortingCdListForCls: "SdsSortingCdListForCls",
  sdsCd: "SdsCd",
  sdaCls: "SdaCls",
  sdaCd: "SdaCd",
}

/** @OK_POS_SDS */

export default function OkPosSdaSds(props) {
  const { itemOptions3, type = "sds" } = props
  const title = `포스 옵션메뉴 설정 (${type})`;

  const [sdaClsList, setSdaClsList] = useState([])
  const [sdaCdList, setSdaCdList] = useState([])

  const [sdsGrList, setSdsGrList] = useState([])
  const [sdsClsList, setSdsClsList] = useState([])
  const [sdsCdList, setSdsCdList] = useState([])

  const [selectedSdsCls, setSelectedSdsCls] = useState({})
  // const [sdsCdListForCls, setSdsCdListForCls] = useState([])
  // const [selectedSdsCdList, setSelectedSdsCdList] = useState({})

  // const [visibleSdsEdit, setVisibleSdsEdit] = useState(false)
  const [visibleSoring, setVisibleSorting] = useState(false)
  const [optionType, setOptionType] = useState(optionTypes.sdsCls)

  const [visibleEdit, setVisibleEdit] = useState(false)
  const [editItem, setEditItem] = useState({})

  useEffect(() => {
    const start = () => {
      if (type === "sds") {
        setSdsGrList(itemOptions3?.SdsGrList || [])
        setSdsClsList(itemOptions3?.SdsClsList || [])
        setSdsCdList(itemOptions3?.SdsCdList || [])
      }

      if (type === "sda") {
        setSdaClsList(itemOptions3?.SdaClsList || [])
        setSdaCdList(itemOptions3?.SdaCdList || [])
      }
    }
    start();
  }, [type, itemOptions3])

  const pageProps = {
    ...props,
    optionTypes,
    optionType, setOptionType,
    sdaClsList, sdaCdList,
    sdsClsList, sdsCdList,
    tableHeaders,
    editItem, setEditItem,
    setVisibleEdit, visibleEdit,
    setVisibleSorting, visibleSoring,

    selectedSdsCls, setSelectedSdsCls,
    // sdsCdListForCls, setSdsCdListForCls,
    // selectedSdsCdList, setSelectedSdsCdList
  }

  return (
    <div>
      {type === "sds" &&
        <CardContainer
          title={title}
          onClickBack={() => props.history.goBack()}
        >
          <DataTableBlock
            {...pageProps}
            optionType={optionTypes.sdsGr}
            tableHeader={tableHeaders.SdsGrList}
            rowItems={sdsGrList}
            setRowItems={setSdsGrList}
            title="선택그룹 리스트"
          />

          <DataTableBlock
            {...pageProps}
            optionType={optionTypes.sdsCls}
            tableHeader={tableHeaders.SdsClsList}
            rowItems={sdsClsList}
            setRowItems={setSdsClsList}
            title="선택분류 리스트"
          />

          <DataTableBlock
            {...pageProps}
            optionType={optionTypes.sdsCd}
            tableHeader={tableHeaders.SdsCdList}
            rowItems={sdsCdList}
            setRowItems={setSdsCdList}
            title="선택아이템 리스트"
          />
        </CardContainer>
      }

      {type === "sda" &&
        <CardContainer
          title={title}
          onClickBack={() => props.history.goBack()}
        >
          <DataTableBlock
            {...pageProps}
            optionType={optionTypes.sdaCls}
            tableHeader={tableHeaders.SdaClsList}
            rowItems={sdaClsList}
            setRowItems={setSdaClsList}
            title="속성분류 리스트"
          />

          <DataTableBlock
            {...pageProps}
            optionType={optionTypes.sdaCd}
            tableHeader={tableHeaders.SdaCdList}
            rowItems={sdaCdList}
            setRowItems={setSdaCdList}
            title="속성아이템 리스트"
          />
        </CardContainer>
      }

      {visibleSoring &&
        <OKPosOptionSortingModal
          {...pageProps}
          visible={visibleSoring}
          setVisible={setVisibleSorting}
          optionType={optionType}
        />
      }

      {visibleEdit &&
        <OKPosOptionEditModal
          {...pageProps}
          visible={visibleEdit}
          setVisible={setVisibleEdit}
          optionType={optionType}
        />
      }
    </div>
  )
}

function DataTableBlock(props) {
  const { gStyle, colors } = useStyles()

  const visibleSelectedCdList = () => {
    const classes = props.rowItems.filter(cls => cls.selected)
    if (classes[0]) {
      props.setSelectedSdsCls(classes[0])
      props.setOptionType(optionTypes.sdsSortingCdListForCls)
      props.setVisibleSorting(true)
    }
    else {
      alert("먼저 항목을 선택해야합니다.")
    }
  }

  const visibleEditItem = () => {
    const classes = props.rowItems.filter(cls => cls.selected)
    if (classes[0]) {
      props.setEditItem(classes[0])
      props.setOptionType(props.optionType)
      props.setVisibleEdit(true)
    }
    else {
      alert("먼저 항목을 선택해야합니다.")
    }
  }

  const styles = {
    subTitleBar: {
      margin: 5,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    subTitleBarLeft: {
      // margin: 5,
      display: "flex",
      alignItems: "center"
    },
    subTitle: {
      ...gStyle.subtitle
    },
    iconPlus: { ...gStyle.subtitle, color: colors.primary, marginLeft: "20px" },
  }

  return (
    <div style={{ marginTop: 15 }}>
      <div style={styles.subTitleBar}>
        <div style={styles.subTitleBarLeft}>
          <p style={styles.subTitle}>{props.title}</p>
          {((props.optionType !== props.optionTypes.sdsGr) && (props.optionType !== props.optionTypes.sdsCd)) &&
            <Sorting
              style={styles.iconPlus}
              onClick={() => {
                props.setOptionType(props.optionType)
                props.setVisibleSorting(true)
              }}
            />
          }
        </div>

        {props.optionType === props.optionTypes.sdsCls &&
          <OnlDropdown
            title="체크항목 편집"
            id="sdscls-setting"
            width={"200px"}
            size="lg"
          >
            <OnlDropdown.Item onClick={visibleEditItem}>선택분류 편집</OnlDropdown.Item>
            <OnlDropdown.Item onClick={visibleSelectedCdList}>선택항목 순서 편집</OnlDropdown.Item>
          </OnlDropdown>
        }

      </div>
      <CustomTable2
        tableHeader={props.tableHeader}
        rowItems={props.rowItems}
        setRowItems={props.setRowItems}
        onClickItem={(obj) => {
          props.setEditItem(obj)
          props.setOptionType(props.optionType)
          props.setVisibleEdit(true)
        }}
      />
    </div>
  )
}
